(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const revealItems = document.querySelectorAll('.mx-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    document.querySelectorAll('[data-mx-filter-group]').forEach((group) => {
      const buttons = group.querySelectorAll('[data-mx-filter]');
      const targetSelector = group.dataset.mxFilterTarget;
      const targets = document.querySelectorAll(targetSelector);

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.mxFilter;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          targets.forEach((target) => {
            const categories = (target.dataset.mxCategories || '').split(' ');
            target.hidden = filter !== 'all' && !categories.includes(filter);
          });
        });
      });
    });

    document.querySelectorAll('[data-mx-accordion]').forEach((accordion) => {
      accordion.querySelectorAll('.mx-accordion__button').forEach((button) => {
        const panelId = button.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          panel.hidden = expanded;
        });
      });
    });

    document.querySelectorAll('[data-mx-game-video]').forEach((video) => {
      const card = video.closest('.mx-game-card');
      if (!card) return;
      card.addEventListener('mouseenter', () => video.play().catch(() => {}));
      card.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  });
})();
